import { DashboardSLAPolicy, ResponseTimeMetric } from 'lib-dashboard-types';
import { PropsWithClassName } from 'lib-shared-types-utils';
import { memo } from 'react';

import { QueueDashboardAverageResponseTimeMetric } from './components/average/averageResponseTimeMetric';
import { QueueDashboardSLAResponseTimeMetric } from './components/sla/slaResponseTimeMetric';

type QueueDashboardResponseTimeMetricProps = {
  /** The response time metric. */
  metric?: ResponseTimeMetric;
  /** The SLA policy which applies to this metric. */
  slaPolicy?: DashboardSLAPolicy;
} & PropsWithClassName;

export const QueueDashboardResponseTimeMetric = memo(
  function QueueDashboardResponseTimeMetric(
    props: QueueDashboardResponseTimeMetricProps,
  ): JSX.Element {
    return props.slaPolicy ? (
      <QueueDashboardSLAResponseTimeMetric
        {...props}
        slaPolicy={props.slaPolicy}
      />
    ) : (
      <QueueDashboardAverageResponseTimeMetric {...props} />
    );
  },
);
